import Announcement from "../components/announcement";
import ClassRoom from "../components/classroom-exp";
import Empowering from "../components/empowering";
import LearningProgramming from "../components/learningProgramming";
import OurContact from "../components/ourContact";
import OurPatners from "../components/ourPartners";
import "../css/index.css";
import Wrapper from "./wrapper";

const Home = () => {
  return (
    <>
      <div>
        <Wrapper>
          <Empowering />
        </Wrapper>
        <Wrapper>
          <ClassRoom />
        </Wrapper>
        <Wrapper>
          <LearningProgramming />
        </Wrapper>
        <Announcement />
        <OurPatners />
        <OurContact />
      </div>
    </>
  );
};

export default Home;
